module.exports = __webpack_public_path__ + "img/o_kutinchev.7616e4c0.jpg";